import { getCountries, getCountryCallingCode, parsePhoneNumberFromString } from "libphonenumber-js";
import { api } from "@/lib/api";

const names = new Intl.DisplayNames(["en"], { type: "region" });
export const DIAL_COUNTRIES = getCountries()
  .map((iso) => ({ iso, name: names.of(iso) || iso, dial: `+${getCountryCallingCode(iso)}` }))
  .sort((a, b) => a.name.localeCompare(b.name));
const KNOWN = new Set(DIAL_COUNTRIES.map((c) => c.iso));

export function toE164(iso, number) {
  const p = parsePhoneNumberFromString(number || "", iso);
  return p && p.isValid() ? p.number : null;
}

let geo;
// Detected ISO country for the dial-code preselect (cached for the page lifetime).
export function detectDialCountry() {
  geo ||= api
    .get("/geo/detect", { params: { tz: Intl.DateTimeFormat().resolvedOptions().timeZone, locale: navigator.language } })
    .then((r) => [r.data.iso, r.data.country].find((c) => c && KNOWN.has(c)) || "PK")
    .catch(() => "PK");
  return geo;
}
